import React, { useEffect, useState } from 'react'
import { Button, Header, Input } from '../../components'
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import Loading from '../../components/Loading';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import axiosClient from '../../axios-client';
import Swal from 'sweetalert2';
import { MdWindow } from 'react-icons/md';
import HourLoading from '../../components/HourLoading';
import { IoReloadCircleOutline } from "react-icons/io5";
import { Pie } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from "chart.js";
import AbsenceLine from './AbsenceLine';
import ObservationsPieChart from './ObservationsPie';
import AbsencesLineChart from './AbsenceLine';
import ActionButton from '../../components/ActionButton';
import VoirExamen from '../examens/VoirExamen';
import { FaEye } from 'react-icons/fa';
import VoirDevoir from '../devoirs/VoirDevoir';

ChartJS.register(ArcElement, Tooltip, Legend);
const InscriptionWindow = ({eleve}) => {
    const { id } = useParams();
    const [observations, setObservations] = useState([]);
    const [absences, setAbsences] = useState([]);
    const [examens, setExamens] = useState([]);
    const [devoirs, setDevoirs] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingExamen, setLoadingExamen] = useState(false);
    const [loadingDevoir, setLoadingDevoir] = useState(false);
    const [loadingInfo, setLoadingInfo] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [showHistoriques, setShowHistoriques] = useState(false);
    const [showAddPaiement, setShowAddPaiement] = useState(false);
    const [showDispense, setShowDispense] = useState(false);
    const [selectedObservation, setSelectedObservation] = useState(null);
    const [showView, setShowView] = useState(false);
    const [selectedExamen, setSelectedExamen] = useState(null);
    const [showViewDevoir, setShowViewDevoir] = useState(false);
    const [selectedDevoir, setSelectedDevoir] = useState(null);
    const [errors, setErrors] = useState(null);
    const { token, setToken, user } = useStateContext();
    const navigate = useNavigate();
    const [inscription, setInscription] = useState({
        id: '',
        nomFr: '',
        nomAr: '',
        matricule: '',
        
    });




    useEffect(() => {
        getObs();
        getAbs();
        // getExamens();
        // getDevoirs();
    }, []);

   

    const getObs = () => {
        axiosClient.get('/eleveObservationDash/' + id)
            .then(response => {
                setObservations(response.data.observations);
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    const getAbs = () => {
        axiosClient.get('/eleveAbsenceDash/' + id)
            .then(response => {
                setAbsences(response.data.absences);
                setInscription({ ...inscription, nomFr: response.data.nomFr,nomAr:response.data.nomAr })
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const getExamens = () => {
        setLoadingExamen(true);
        axiosClient.get('/fenetre/examens/' + id)
            .then(response => {
                setExamens(response.data.examens);
                setLoadingExamen(false);
            }).catch(err => {
                const response = err.response;
                setLoadingExamen(false);
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    const getDevoirs = () => {
        setLoadingDevoir(true);
        axiosClient.get('/fenetre/devoirs/' + id)
            .then(response => {
                setDevoirs(response.data.devoirs);
                setLoadingDevoir(false);
            }).catch(err => {
                const response = err.response;
                setLoadingDevoir(false);
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    const closeShow = () => {
        setShowView(false);
        setSelectedExamen(null);
    }
    const closeShowDevoir = () => {
        setShowViewDevoir(false);
        setSelectedDevoir(null);
    }



    return (
        <>
            <Header icon={<MdWindow />} category='Page' title={`Fenetre eleve   ${inscription.nomFr}`} Elève titleAr={`   نافذة طالب ${inscription.nomFr}  `} />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            {loadingInfo ? <HourLoading /> :
                <div className='flex-col '>
                    <div className="flex-col w-full mb-2 gap-2">
                        <div className="flex mb-2 w-full flex-col p-6 bg-white rounded-xl shadow-md border border-gray-200">
                            <div className="flex items-center gap-2 border-b border-gray-100 pb-3 mb-3">
                                <div className="w-1 h-6 bg-blue-500 rounded"></div>
                                <h2 className="text-lg font-semibold text-gray-800">Observations</h2>
                            </div>
                            <div className="flex flex-wrap justify-between">
                                <div className="overflow-auto h-64 max-h-64 ">
                                    <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md">
                                        <thead>
                                            <tr className=" text-white text-left">
                                                <th className="bg-blue-700 px-6 py-3 rounded-tl-xl">Date</th>
                                                <th className="bg-blue-700 px-6 py-3">Content</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {observations.map((a, index) => (
                                                <tr
                                                    key={index}
                                                    className={`border-b border-gray-100  hover:bg-blue-50 transition`}
                                                >
                                                    <td className="px-6 py-3 font-medium text-gray-700">{a.dateObservation}</td>
                                                    <td className="px-6 py-3 text-gray-600">{a.content}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="flex h-64 max-h-64">
                                    <ObservationsPieChart observations={observations} />
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full flex-col p-6 bg-white rounded-xl shadow-md border border-red-200">
                            <div className="flex items-center gap-2 border-b border-red-100 pb-3 mb-3">
                                <div className="w-1 h-6 bg-red-500 rounded"></div>
                                <h2 className="text-lg font-semibold text-red-600">Absences</h2>
                            </div>
                            <div className="flex flex-wrap justify-between gap-2">
                                <div className="overflow-auto h-64 max-h-64 ">
                                    <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md">
                                        <thead>
                                            <tr className=" text-white text-left">
                                                <th className="bg-red-700 px-6 py-3 rounded-tl-xl">Date</th>
                                                <th className="bg-red-700 px-6 py-3">Matière</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {absences.map((a, index) => (
                                                <tr
                                                    key={index}
                                                    className={`border-b border-gray-100  hover:bg-blue-50 transition`}
                                                >
                                                    <td className="px-6 py-3 font-medium text-gray-700">{a.dateAbsence}</td>
                                                    <td className="px-6 py-3 text-gray-600">{a.matiereLibelle}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="flex h-60 max-h-60 ">
                                    <AbsencesLineChart className="h-60 max-h-60" absences={absences} />
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="flex flex-wrap justify-between">
                        <div className="flex flex-col p-6 bg-white rounded-xl shadow-md border border-purple-200">
                            <div className="flex items-center gap-2 justify-between border-b border-purple-100 pb-3 mb-3">
                                <div className="flex gap-2 items-center">
                                    <div className="w-1 h-6 bg-purple-500 rounded"></div>
                                    <h2 className="green-700 font-semibold text-purple-600">Examens</h2>
                                </div>
                                <ActionButton color="bg-salt-100" icon={<IoReloadCircleOutline />} textColor="text-purple-700" size="text-3xl" onClick={() => {
                                    getExamens();
                                 }} />
                            </div>
                            <div className="overflow-auto h-64 max-h-64 ">
                                {
                                    loadingExamen ? <Loading /> :
                                        <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md">
                                            <thead>
                                                <tr className=" text-white text-left">
                                                    <th className="bg-purple-700 px-6 py-3">Matière</th>
                                                    <th className="bg-purple-700 px-6 py-3">Trimestre</th>
                                                    <th className="bg-purple-700 px-6 py-3"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {examens.map((a, index) => (
                                                    <tr
                                                        key={index}
                                                        className={`border-b border-gray-100  hover:bg-blue-50 transition`}
                                                    >

                                                        <td className="px-3 py-3 text-gray-600">{a.matiereLibelle}</td>
                                                        <td className="px-3 py-3 text-gray-600">{a.trimestre.code}</td>
                                                        <td className="px-3 py-3 text-gray-600">
                                                            <ActionButton onClick={() => {
                                                                setSelectedExamen(a);
                                                                setShowView(true);
                                                            }} color="bg-purple-500" icon={<FaEye />} textColor="text-white" title="Voir" />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                }
                            </div>
                        </div>
                        <div className="flex flex-col p-6 bg-white rounded-xl shadow-md border border-green-200">
                            <div className="flex items-center gap-2 justify-between border-b border-green-100 pb-3 mb-3">
                                <div className="flex gap-2">
                                    <div className="w-1 h-6 bg-green-500 rounded"></div>
                                    <h2 className="text-lg font-semibold text-green-600">Devoirs</h2>
                                </div>
                                <ActionButton color="bg-salt-100" icon={<IoReloadCircleOutline />} textColor="text-green-700" size="text-3xl" onClick={() => {
                                    getDevoirs();
                                 }} />
                            </div>
                            <div className="overflow-auto h-64 max-h-64 ">
                                {
                                    loadingDevoir ? <Loading /> :
                                        <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow-md">
                                            <thead>
                                                <tr className=" text-white text-left">

                                                    <th className="bg-lime-700 px-6 py-3">Matière</th>
                                                    <th className="bg-lime-700 px-6 py-3">Trimestre</th>
                                                    <th className="bg-lime-700 px-6 py-3"></th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {devoirs.map((a, index) => (
                                                    <tr
                                                        key={index}
                                                        className={`border-b border-gray-100  hover:bg-blue-50 transition`}
                                                    >

                                                        <td className="px-3 py-3 text-gray-600">{a.matiereLibelle}</td>
                                                        <td className="px-3 py-3 text-gray-600">{a.trimestre.code}</td>
                                                        <td className="px-3 py-3 text-gray-600">
                                                            <ActionButton onClick={() => {
                                                                setSelectedDevoir(a);
                                                                setShowViewDevoir(true);
                                                            }} color="bg-lime-500" icon={<FaEye />} textColor="text-white" title="Voir" />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                }
                            </div>
                        </div>
                        {
                            showView ? <VoirExamen selectedExamen={selectedExamen} onClose={closeShow} /> : <></>
                        }
                        {
                            showViewDevoir ? <VoirDevoir selectedDevoir={selectedDevoir} onClose={closeShowDevoir} /> : <></>
                        }

                    </div>
                </div>
            }
        </>
    )
}

export default InscriptionWindow